import React, { useState, useEffect, useCallback, memo } from 'react';
import { FaPlus, FaChevronDown, FaChevronUp, FaCheckCircle, FaClock, FaPaperclip, FaDownload, FaTimes } from 'react-icons/fa';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import pb from '../lib/pocketbase';
import { useCompany } from '../context/CompanyContext';
pb.autoCancellation(false);

const quillModules = {
  toolbar: [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'color': [] }, { 'background': [] }],
    ['link', 'image'],
    ['clean']
  ],
};

const quillFormats = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'list', 'bullet',
  'color', 'background',
  'link', 'image'
];

const ReplyForm = memo(({ ticketId, onClose, onSubmit, uploading }) => {
  const [formData, setFormData] = useState({
    Communication: '',
    Screenshot: null
  });

  const handleSubmit = useCallback(() => {
    onSubmit(ticketId, formData);
  }, [ticketId, formData, onSubmit]);

  const handleContentChange = useCallback((content) => {
    setFormData(prev => ({ ...prev, Communication: content }));
  }, []);

  const handleFileChange = useCallback((e) => {
    if (e.target.files && e.target.files[0]) {
      setFormData(prev => ({ ...prev, Screenshot: e.target.files[0] }));
    }
  }, []);

  const isSubmitDisabled = !formData.Communication.trim() || uploading;

  return (
    <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200 mb-4 flex flex-col">
  <h4 className="text-lg font-semibold text-[#0a1744] mb-4">Write Your Update</h4>

  <div className="flex flex-col gap-6 flex-grow overflow-y-auto">
    <div className="flex items-center gap-4">
      <label className="flex items-center gap-2 cursor-pointer">
        <FaPaperclip className="text-[#0a1744]" />
        <span className="text-sm text-gray-600">Attach Screenshot</span>
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="hidden"
        />
      </label>
      {formData.Screenshot && (
        <span className="text-sm text-gray-600">{formData.Screenshot.name}</span>
      )}
    </div>

    <div>
      <ReactQuill
        value={formData.Communication}
        onChange={handleContentChange}
        modules={quillModules}
        formats={quillFormats}
        placeholder="Type your message here..."
        className="bg-white rounded-lg"
        style={{ height: '200px' }}
      />
    </div>
  </div>

  <div className="flex justify-end gap-2 mt-6">
    <button
      onClick={onClose}
      className="px-4 py-2 text-gray-600 hover:text-gray-800"
    >
      Cancel
    </button>
    <button
      onClick={handleSubmit}
      disabled={isSubmitDisabled}
      className="px-4 py-2 bg-[#0a1744] text-white rounded-lg hover:bg-[#A1E744] hover:text-[#0a1744] transition-colors duration-200 disabled:opacity-50"
    >
      {uploading ? 'Submitting...' : 'Submit Reply'}
    </button>
  </div>
</div>

  );
});

const Tickets = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMounted, setIsMounted] = useState(false);
  const [expandedTickets, setExpandedTickets] = useState({});
  const [supportMembers, setSupportMembers] = useState({});
  const [showReplyForm, setShowReplyForm] = useState(null);
  const [showNewTicketForm, setShowNewTicketForm] = useState(false);
  const [replyForm, setReplyForm] = useState({
    Communication: '',
    Screenshot: null
  });
  const [newTicketForm, setNewTicketForm] = useState({
    Title: '',
    Communication: '',
    Screenshot: null
  });
  const [uploading, setUploading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [visibleReplies, setVisibleReplies] = useState({});
  const REPLIES_PER_PAGE = 3;
  const { currentCompanyId } = useCompany();

  // Toast component
  const Toast = ({ message, type }) => {
    if (!message) return null;
    
    return (
      <div className={`fixed top-4 right-4 px-6 py-3 rounded-lg shadow-lg text-white z-50 transform transition-all duration-300 ${
        type === 'success' ? 'bg-[#A1E744]' : 'bg-red-500'
      }`}>
        {message}
      </div>
    );
  };

  // Function to show toast
  const showToast = (message, type) => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: '', type: '' });
    }, 3000);
  };

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => {
    if (isMounted) {
      fetchTickets();
    }
  }, [isMounted, currentCompanyId]);

  const fetchSupportMember = async (memberId) => {
    if (!memberId || supportMembers[memberId]) return;

    try {
      const member = await pb.collection('Contacts').getOne(memberId);
      if (isMounted) {
        setSupportMembers(prev => ({
          ...prev,
          [memberId]: `${member.Name} ${member.Surname}`
        }));
      }
    } catch (error) {
      console.error('Error fetching support member:', error);
    }
  };

  const toggleTicketExpansion = (ticketId) => {
    setExpandedTickets(prev => ({
      ...prev,
      [ticketId]: !prev[ticketId]
    }));
  };
  useEffect(() =>  console.log("support member " , supportMembers) , []);

  const calculateTimeDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffInHours = Math.abs(end - start) / 36e5; // Convert to hours

    if (diffInHours < 24) {
      return `${Math.round(diffInHours)} hours`;
    } else {
      const days = Math.floor(diffInHours / 24);
      const remainingHours = Math.round(diffInHours % 24);
      return `${days} days ${remainingHours} hours`;
    }
  };

  const fetchTickets = async () => {
    if (!isMounted) return;

    try {
      setLoading(true);
      const pbAuth = JSON.parse(localStorage.getItem('pocketbase_auth') || '{}');
      const companyId = currentCompanyId || pbAuth?.record?.CompanyID;

      if (!companyId) {
        if (isMounted) {
          setError('Company ID not found');
        }
        return;
      }

      const records = await pb.collection('Tickets').getList(1, 50, {
        filter: `CompanyID = "${companyId}"`,
        sort: '-created'
      });

      if (isMounted) {
        if (records && records.items) {
          const parentTickets = records.items.filter(ticket => !ticket.Reference);
          const childTickets = records.items.filter(ticket => ticket.Reference);

          const organizedTickets = parentTickets.map(parent => ({
            ...parent,
            replies: childTickets
              .filter(child => child.Reference === parent.id)
              .sort((a, b) => new Date(a.created) - new Date(b.created))
          }));

          setTickets(organizedTickets);
          console.log('Tickets state updated:', organizedTickets);

          // Fetch support member details for each ticket and its replies
          organizedTickets.forEach(ticket => {
            // Fetch for parent ticket
            if (ticket.SupportMember) {
              fetchSupportMember(ticket.SupportMember);
            }
            if (ticket.Initiator) {
              fetchSupportMember(ticket.Initiator);
            }
            
            // Fetch for replies
            if (ticket.replies) {
              ticket.replies.forEach(reply => {
                if (reply.SupportMember) {
                  fetchSupportMember(reply.SupportMember);
                }
                if (reply.Initiator) {
                  fetchSupportMember(reply.Initiator);
                }
              });
            }
          });
        } else {
          setTickets([]);
        }
      }
    } catch (error) {
      if (isMounted) {
        console.error('Error fetching tickets:', error);
        setError('Failed to fetch tickets');
      }
    } finally {
      if (isMounted) {
        setLoading(false);
      }
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleString();
  };

  const handleImageUpload = async (file, isNewTicket = false) => {
    if (!file) return null;
    
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const record = await pb.collection('Tickets').create(formData);
      return record.id;
    } catch (error) {
      console.error('Error uploading image:', error);
      return null;
    }
  };

  const handleReplySubmit = useCallback(async (ticketId, formData) => {
    try {
      setUploading(true);
      const pbAuth = JSON.parse(localStorage.getItem('pocketbase_auth') || '{}');
      const companyId = currentCompanyId || pbAuth?.record?.CompanyID;
      const userId = pbAuth?.record?.id;

      if (!companyId || !userId) {
        setError('Required information not found');
        return;
      }

      let screenshotId = null;
      if (formData.Screenshot) {
        screenshotId = await handleImageUpload(formData.Screenshot);
      }

      const replyData = {
        Communication: formData.Communication,
        Reference: ticketId,
        CompanyID: companyId,
        CompanyIDArray: [companyId],
        Initiator: userId,
        Screenshot: screenshotId
      };

      await pb.collection('Tickets').create(replyData);
      
      // Show success toast
      showToast('Reply submitted successfully!', 'success');

      // Fetch the parent ticket to determine who to notify
      try {
        const parentTicket = await pb.collection('Tickets').getOne(ticketId, {
          expand: 'Initiator,SupportMember', // Expand both to get email and name
        });

        const replierId = userId; // The user who submitted the reply
        const customerId = parentTicket.Initiator;
        const asoId = parentTicket.SupportMember;

        console.log('Reply submitted:', { ticketId, replierId, customerId, asoId });
        console.log('Parent ticket expanded data:', parentTicket.expand);

        let recipientEmail = null;
        let subject = '';
        let htmlBody = '';

        if (replierId === customerId) {
          // Customer replied, notify ASO
          console.log('Customer replied. Checking ASO email...', parentTicket.expand?.SupportMember?.email);
          if (parentTicket.expand?.SupportMember?.email) {
            recipientEmail = parentTicket.expand.SupportMember.email;
            subject = `ATraqll: New customer update on ticket #${parentTicket.id}`;
            htmlBody = `
              <p>Hello ${parentTicket.expand.SupportMember.Name || 'Support Officer'},</p>
              <p>There is a new update from the customer on ticket #${parentTicket.id}.</p>
              <p>Please log in to the portal to view the update.</p>
            `;
          }
        } else if (replierId === asoId) {
          // ASO replied, notify customer
          console.log('ASO replied. Checking customer email...', parentTicket.expand?.Initiator?.email);
          if (parentTicket.expand?.Initiator?.email) {
            recipientEmail = parentTicket.expand.Initiator.email;
            subject = `ATraqll: New update on your ticket #${parentTicket.id}`;
            htmlBody = `
              <p>Hi ${parentTicket.expand.Initiator.Name || 'Customer'},</p>
              <p>There is a new update from the support team on your ticket #${parentTicket.id}.</p>
              <p>Please log in to the portal to view the update.</p>
            `;
          }
        }
        
        if (recipientEmail && subject && htmlBody) {
          console.log('Attempting to send email to:', recipientEmail);
          // Send email using the backend endpoint
          const response = await fetch('https://common.a-traq.com/api/email/send-email', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ to: recipientEmail, subject, html: htmlBody }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            console.error('Error sending new reply email:', errorData);
            // Optionally show an error toast to the user
            // showToast('Failed to send new reply notification email.', 'error');
          } else {
            console.log('New reply notification email sent successfully.');
          }
        } else {
           console.log('Email not sent. Recipient or content missing.', { recipientEmail, subject: !!subject, htmlBody: !!htmlBody });
        }

      } catch (error) {
        console.error('Error sending new reply notification email:', error);
        // Optionally show an error toast to the user
        // showToast('Failed to send new reply notification email.', 'error');
      }
      
      setShowReplyForm(null);
      
      // Refresh the ticket list
      await fetchTickets();
    } catch (error) {
      console.error('Error submitting reply:', error);
      setError('Failed to submit reply');
      showToast('Failed to submit reply. Please try again.', 'error');
    } finally {
      setUploading(false);
    }
  }, []);

  const handleNewTicketSubmit = useCallback(async (formData) => {
    try {
      setUploading(true);
      const pbAuth = JSON.parse(localStorage.getItem('pocketbase_auth') || '{}');
      const companyId = currentCompanyId || pbAuth?.record?.CompanyID;
      const userId = pbAuth?.record?.id;

      if (!companyId || !userId) {
        setError('Required information not found');
        return;
      }

      const ticketFormData = new FormData();
      
      // Add all required fields
      ticketFormData.append('Title', formData.Title);
      ticketFormData.append('Communication', formData.Communication);
      ticketFormData.append('CompanyID', companyId);
      ticketFormData.append('Initiator', userId);
      
      // Add screenshot if exists
      if (formData.Screenshot) {
        ticketFormData.append('Screenshot', formData.Screenshot);
      }

      // Create the ticket with all data
      const newTicketRecord = await pb.collection('Tickets').create(ticketFormData);
      
      // Fetch support officers with IsTicketSupport true
      const supportOfficers = await pb.collection('Contacts').getList(1, 100, {
        filter: 'IsTicketSupport = true'
      });

      if (supportOfficers.items.length > 0) {
        const supportEmails = supportOfficers.items.map(officer => officer.email).filter(Boolean);
        if (supportEmails.length > 0) {
          const subject = `New Support Ticket Created (#${newTicketRecord.id})`;
          const htmlBody = `
            <p>A new support ticket has been created:</p>
            <p><strong>Title:</strong> ${newTicketRecord.Title}</p>
            <p><strong>Communication:</strong> ${newTicketRecord.Communication}</p>
            <p>Please log in to the portal to view and assign the ticket.</p>
          `; // Basic HTML for new ticket notification

          // Send email using the backend endpoint
          try {
            const response = await fetch('https://common.a-traq.com/api/email/send-email', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ to: supportEmails, subject, html: htmlBody }),
            });

            if (!response.ok) {
              const errorData = await response.json();
              console.error('Error sending new ticket email:', errorData);
              // Optionally show an error toast to the user
              // showToast('Failed to send new ticket notification email.', 'error');
            } else {
              console.log('New ticket notification email sent successfully.');
            }
          } catch (error) {
            console.error('Error sending new ticket email:', error);
            // Optionally show an error toast to the user
            // showToast('Failed to send new ticket notification email.', 'error');
          }
        }
      }

      // Show success toast
      showToast('Ticket created successfully!', 'success');

      setShowNewTicketForm(false);
      
      // Refresh the ticket list
      await fetchTickets();
    } catch (error) {
      console.error('Error creating new ticket:', error);
      setError('Failed to create new ticket');
      showToast('Failed to create ticket. Please try again.', 'error');
    } finally {
      setUploading(false);
    }
  }, []);

  const handleMarkAsResolved = async (ticketId) => {
    try {
      setUploading(true);
      const currentTime = new Date().toISOString();
      
      // Update the ticket with the current timestamp
      await pb.collection('Tickets').update(ticketId, {
        TicketClose: currentTime
      });
      
      // Show success toast
      showToast('Ticket marked as resolved successfully!', 'success');
      
      // Refresh the ticket list to show updated status
      await fetchTickets();
    } catch (error) {
      console.error('Error marking ticket as resolved:', error);
      showToast('Failed to mark ticket as resolved. Please try again.', 'error');
    } finally {
      setUploading(false);
    }
  };

  const loadMoreReplies = (ticketId) => {
    setVisibleReplies(prev => ({
      ...prev,
      [ticketId]: (prev[ticketId] || REPLIES_PER_PAGE) + REPLIES_PER_PAGE
    }));
  };

  const NewTicketForm = memo(({ onClose, onSubmit, uploading }) => {
    const [formData, setFormData] = useState({
      Title: '',
      Communication: '',
      Screenshot: null
    });

    const handleContentChange = useCallback((content) => {
      setFormData(prev => ({ ...prev, Communication: content }));
    }, []);

    const handleTitleChange = useCallback((e) => {
      setFormData(prev => ({ ...prev, Title: e.target.value }));
    }, []);

    const handleFileChange = useCallback((e) => {
      if (e.target.files && e.target.files[0]) {
        setFormData(prev => ({ ...prev, Screenshot: e.target.files[0] }));
      }
    }, []);

    const handleSubmit = useCallback(() => {
      onSubmit(formData);
    }, [formData, onSubmit]);

    const isSubmitDisabled = !formData.Title.trim() || !formData.Communication.trim() || uploading;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-auto">
  <div className="bg-white rounded-lg p-6 max-w-2xl w-full flex flex-col">
    <h3 className="text-2xl font-bold text-[#0a1744] mb-4">Create New Ticket</h3>

    <div className="flex flex-col gap-6 flex-grow overflow-y-auto">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
        <input
          type="text"
          value={formData.Title}
          onChange={handleTitleChange}
          className="w-full p-2 border border-gray-300 rounded-lg"
          placeholder="Enter ticket title"
        />
      </div>

      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2 cursor-pointer">
          <FaPaperclip className="text-[#0a1744]" />
          <span className="text-sm text-gray-600">Attach Screenshot</span>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="hidden"
          />
        </label>
        {formData.Screenshot && (
          <span className="text-sm text-gray-600">{formData.Screenshot.name}</span>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
        <ReactQuill
          value={formData.Communication}
          onChange={handleContentChange}
          modules={quillModules}
          formats={quillFormats}
          placeholder="Describe your issue..."
          className="bg-white rounded-lg"
          style={{ height: '200px' }}
        />
      </div>
    </div>

    {/* Buttons */}
    <div className="flex justify-end gap-2 mt-6">
      <button
        onClick={onClose}
        className="px-4 py-2 text-gray-600 hover:text-gray-800"
      >
        Cancel
      </button>
      <button
        onClick={handleSubmit}
        disabled={isSubmitDisabled}
        className="px-4 py-2 bg-[#0a1744] text-white rounded-lg hover:bg-[#A1E744] hover:text-[#0a1744] transition-colors duration-200 disabled:opacity-50"
      >
        {uploading ? 'Creating...' : 'Create Ticket'}
      </button>
    </div>
  </div>
</div>

    );
  });

  const ImageModal = ({ image, onClose }) => {
    if (!image) return null;

    const handleDownload = async () => {
      try {
        const response = await fetch(pb.getFileUrl(`${process.env.REACT_APP_PB_URL}/api/files/Tickets/${image.id}/${image.Screenshot[0]}`, `${process.env.REACT_APP_PB_URL}/api/files/Tickets/${image.id}/${image.Screenshot[0]}`));
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `ticket-screenshot-${Date.now()}.png`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } catch (error) {
        console.error('Error downloading image:', error);
      }
    };

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-auto">
        <div className="bg-white rounded-lg p-4 max-w-4xl w-full">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-[#0a1744]">Screenshot</h3>
            <div className="flex items-center gap-4">
              {/* <button
                onClick={handleDownload}
                className="text-[#0a1744] hover:text-[#A1E744] transition-colors duration-200 flex items-center"
              >
                <FaDownload className="mr-2" />
                Download
              </button> */}
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 transition-colors duration-200"
              >
                <FaTimes size={20} />
              </button>
            </div>
          </div>
          <div className="relative">
            <img
              src={`${process.env.REACT_APP_PB_URL}/api/files/Tickets/${image.id}/${image.Screenshot[0]}`}
              alt="Ticket Screenshot"
              className="max-h-[80vh] w-full object-contain rounded-lg"
            />
          </div>
        </div>
      </div>
    );
  };

  const Thumbnail = ({ image }) => {
    console.log("image >>>" , image)
    if (!image) return null;

    return (
      <div className="w-24 h-24 rounded-lg overflow-hidden border border-gray-200 cursor-pointer hover:border-[#A1E744] transition-colors duration-200">
        <img
          src={`${process.env.REACT_APP_PB_URL}/api/files/Tickets/${image.id}/${image.Screenshot[0]}`}
          alt="Screenshot thumbnail"
          className="w-full h-full object-cover"
          onClick={() => setSelectedImage(image)}
        />
      </div>
    );
  };

  if (loading) {
    return (
      <div className="p-4 sm:p-6">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#0a1744] bg-gradient-to-r from-[#0a1744] to-[#A1E744] bg-clip-text text-transparent mb-6 sm:mb-8">Support Tickets</h1>
        
        <div className="bg-white rounded-lg shadow-lg border-2 border-gray-100 p-4 sm:p-6">
          <div className="flex justify-between items-center mb-6 sm:mb-8">
            <button
              className="px-3 sm:px-4 py-2 bg-[#0a1744] text-white rounded-lg hover:bg-[#A1E744] hover:text-[#0a1744] transition-colors duration-200 flex items-center text-sm sm:text-base"
            >
              <FaPlus className="mr-2" />
              New Ticket
            </button>
          </div>

          <div className="space-y-4 sm:space-y-6">
            {[1, 2, 3].map((index) => (
              <div key={index} className="bg-white rounded-lg shadow-md border border-gray-200">
                <div className="p-4 sm:p-6">
                  <div className="flex flex-col sm:flex-row justify-between items-start gap-4 mb-4">
                    <div className="flex-1 w-full">
                      <div className="flex flex-wrap items-center gap-2 sm:gap-4 mb-2">
                        <div className="h-6 w-24 bg-gray-200 rounded-full animate-pulse"></div>
                        <div className="h-6 w-16 bg-gray-200 rounded-full animate-pulse"></div>
                      </div>
                      <div className="h-6 w-3/4 bg-gray-200 rounded animate-pulse mb-2"></div>
                      <div className="space-y-2">
                        <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-4 w-5/6 bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-4 w-4/6 bg-gray-200 rounded animate-pulse"></div>
                      </div>
                    </div>
                    <div className="w-24 h-24 bg-gray-200 rounded-lg animate-pulse"></div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-gray-600 border-t border-gray-100 pt-4 mt-4">
                    <div className="space-y-2">
                      <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
                      <div className="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                    <div className="space-y-2">
                      <div className="h-4 w-36 bg-gray-200 rounded animate-pulse"></div>
                      <div className="h-4 w-28 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-6">
      <h1 className="text-3xl sm:text-4xl font-bold text-[#0a1744] bg-gradient-to-r from-[#0a1744] to-[#A1E744] bg-clip-text text-transparent mb-6 sm:mb-8">Support Tickets</h1>
      
      {/* Toast Notification */}
      {toast.show && <Toast message={toast.message} type={toast.type} />}

      <div className="bg-white rounded-lg shadow-lg border-2 border-gray-100 p-4 sm:p-6">
        <div className="flex justify-between items-center mb-6 sm:mb-8">
          <button
            onClick={() => setShowNewTicketForm(true)}
            className="px-3 sm:px-4 py-2 bg-[#0a1744] text-white rounded-lg hover:bg-[#A1E744] hover:text-[#0a1744] transition-colors duration-200 flex items-center text-sm sm:text-base"
          >
            <FaPlus className="mr-2" />
            New Ticket
          </button>
        </div>

        {error && <div className="text-red-600 mb-4">{error}</div>}

        <div className="space-y-4 sm:space-y-6">
          {tickets.length === 0 ? (
            <p className="text-gray-500 text-center">No tickets found</p>
          ) : (
            tickets.map((ticket) => (
              <div key={ticket.id} className="bg-white rounded-lg shadow-md border border-gray-200 hover:border-[#A1E744] transition-colors duration-200">
                <div className="p-4 sm:p-6">
                  <div className="flex flex-col sm:flex-row justify-between items-start gap-4 mb-4">
                    <div className="flex-1 w-full">
                      <div className="flex flex-wrap items-center gap-2 sm:gap-4 mb-2">
                        <div className="bg-[#0a1744] text-white px-3 py-1 rounded-full text-sm">
                          Ticket-{ticket.id}
                        </div>
                        <div className={`px-3 py-1 rounded-full text-sm ${
                          ticket.TicketClose 
                            ? 'bg-green-100 text-green-800' 
                            : 'bg-yellow-100 text-yellow-800'
                        }`}>
                          {ticket.TicketClose ? 'Closed' : 'Open'}
                        </div>
                        {!ticket.TicketClose && (
                          <button
                            onClick={() => handleMarkAsResolved(ticket.id)}
                            disabled={uploading}
                            className="px-3 py-1 bg-green-500 text-white rounded-full text-sm hover:bg-green-600 transition-colors duration-200 disabled:opacity-50"
                          >
                            {uploading ? 'Processing...' : 'Mark As Resolved'}
                          </button>
                        )}
                      </div>
                      <h3 className="text-lg font-semibold text-[#0a1744] mb-2">{ticket.Title}</h3>
                      <div 
                        className="text-gray-600 mb-4 prose prose-sm max-w-none"
                        dangerouslySetInnerHTML={{ __html: ticket.Communication }}
                      />
                    </div>
                    {ticket.Screenshot && ticket.Screenshot.length > 0 && (
                      <div className="w-full sm:w-auto sm:ml-4">
                        <Thumbnail image={ticket} />
                      </div>
                    )}
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-gray-600 border-t border-gray-100 pt-4 mt-4">
                    <div>
                      <p><span className="font-bold">Created:</span> {formatDate(ticket.created)}</p>
                      {ticket.updated && <p><span className="font-bold">Updated:</span> {formatDate(ticket.updated)}</p>}
                      {ticket.TicketClose && (
                        <p><span className="font-bold">Closed:</span> {formatDate(ticket.TicketClose)}</p>
                      )}
                    </div>
                    <div>
                      {ticket.SupportMember && (
                        <p><span className="font-bold">Assigned to:</span> {supportMembers[ticket.SupportMember] || 'Loading...'}</p>
                      )}
                      {ticket.Initiator && (
                        <p><span className="font-bold">Created by:</span> {supportMembers[ticket.Initiator] || 'Loading...'}</p>
                      )}
                      {ticket.TicketClose && (
                        <p><span className="font-bold">Time to close:</span> {calculateTimeDifference(ticket.created, ticket.TicketClose)}</p>
                      )}
                    </div>
                  </div>

                  {!ticket.TicketClose && (
                    <div className="mt-4">
                      <button
                        onClick={() => setShowReplyForm(ticket.id)}
                        className="text-[#0a1744] hover:text-[#A1E744] transition-colors duration-200 flex items-center"
                      >
                        <FaPlus className="mr-2" />
                        Write Your Update
                      </button>
                    </div>
                  )}

                  {showReplyForm === ticket.id && (
                    <ReplyForm
                      ticketId={ticket.id}
                      onClose={() => setShowReplyForm(null)}
                      onSubmit={handleReplySubmit}
                      uploading={uploading}
                    />
                  )}

                  {ticket.replies && ticket.replies.length > 0 && (
                    <div className="mt-6 flex justify-center">
                      <button
                        onClick={() => toggleTicketExpansion(ticket.id)}
                        className="px-4 sm:px-6 py-2 bg-[#0a1744] text-white rounded-lg hover:bg-[#A1E744] hover:text-[#0a1744] transition-colors duration-200 flex items-center text-sm sm:text-base"
                      >
                        {expandedTickets[ticket.id] ? (
                          <>
                            Hide Conversation <FaChevronUp className="ml-2" />
                          </>
                        ) : (
                          <>
                            Show Conversation <FaChevronDown className="ml-2" />
                          </>
                        )}
                      </button>
                    </div>
                  )}

                  {expandedTickets[ticket.id] && ticket.replies && ticket.replies.length > 0 && (
                    <div className="mt-6 space-y-4">
                      {ticket.replies
                        .slice(0, visibleReplies[ticket.id] || REPLIES_PER_PAGE)
                        .map((reply) => (
                          <div key={reply.id} className="bg-gray-50 rounded-lg p-4 border-2 border-[#0a1744]">
                            <div className="flex flex-col sm:flex-row justify-between items-start gap-4">
                              <div className="flex-1">
                                <div 
                                  className="text-gray-700 prose prose-sm max-w-none"
                                  dangerouslySetInnerHTML={{ __html: reply.Communication }}
                                />
                                <div className="text-sm text-gray-500 mt-2">
                                  <span className="font-bold">Created:</span> {formatDate(reply.created)}
                                  {reply.updated && <span className="ml-4"><span className="font-bold">Updated:</span> {formatDate(reply.updated)}</span>}
                                </div>
                                {reply.Initiator && (
                                  <p className="text-sm text-gray-500 mt-1">
                                    <span className="font-bold">By:</span> {supportMembers[reply.Initiator] || 'Loading...'}
                                  </p>
                                )}
                                {reply.SupportMember && (
                                  <p className="text-sm text-gray-500 mt-1">
                                    <span className="font-bold">Assigned to:</span> {supportMembers[reply.SupportMember] || 'Loading...'}
                                  </p>
                                )}
                              </div>
                              {reply.Screenshot && reply.Screenshot.length > 0 && (
                                <div className="w-full sm:w-auto sm:ml-4">
                                  <Thumbnail image={reply} />
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      
                      {ticket.replies.length > (visibleReplies[ticket.id] || REPLIES_PER_PAGE) && (
                        <div className="flex justify-center mt-4">
                          <button
                            onClick={() => loadMoreReplies(ticket.id)}
                            className="px-4 py-2 bg-[#0a1744] text-white rounded-lg hover:bg-[#A1E744] hover:text-[#0a1744] transition-colors duration-200"
                          >
                            Load More
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {showNewTicketForm && (
        <NewTicketForm
          onClose={() => setShowNewTicketForm(false)}
          onSubmit={handleNewTicketSubmit}
          uploading={uploading}
        />
      )}
      {selectedImage && <ImageModal image={selectedImage} onClose={() => setSelectedImage(null)} />}
    </div>
  );
};

export default Tickets; 